import { LoginComponent } from './LoginComponent.tsx';
import { LoginHook } from './LoginHook.tsx';

export function LoginController() {
    return <LoginComponent {...LoginHook()} />;
}
